import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import { Toaster } from "@/shared/ui/toast/toaster";

import AuthProvider from "./AuthProvider";
import MaintenanceProvider from "./MaintenanceProvider";
import NetworkErrorProvider from "./NetworkErrorProvider";
import QueryProvider from "./QueryProvider";
import ScrollToTop from "./ScrollToTop";
import WebEntryProvider from "./WebEntryProvider";

export default function AppProvider({ children }: AppProviderProps) {
  const isDev = import.meta.env.DEV;

  return (
    <BrowserRouter>
      <ScrollToTop />
      <QueryProvider>
        <HelmetProvider>
          <NetworkErrorProvider>
            <AuthProvider>
              <MaintenanceProvider>
                {isDev ? (
                  <>
                    {children}
                    <Toaster />
                  </>
                ) : (
                  <WebEntryProvider>
                    {children}
                    <Toaster />
                  </WebEntryProvider>
                )}
              </MaintenanceProvider>
            </AuthProvider>
          </NetworkErrorProvider>
        </HelmetProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}

interface AppProviderProps {
  children: React.ReactNode;
}
